/* ============================================================
   CECO Header — panel "Categorías" (drawer overlay)
   Abre/cierra con el botón, overlay, botón de cerrar y Esc.
   ============================================================ */
(function () {
  'use strict';

  function panel() { return document.querySelector('[data-ceco-cat-panel]'); }
  function toggleBtn() { return document.querySelector('[data-ceco-cat-toggle]'); }

  function open() {
    var p = panel();
    if (!p) return;
    p.hidden = false;
    document.body.style.overflow = 'hidden';
    var t = toggleBtn();
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function close() {
    var p = panel();
    if (!p) return;
    p.hidden = true;
    document.body.style.overflow = '';
    var t = toggleBtn();
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ceco-cat-toggle]')) {
      e.preventDefault();
      var p = panel();
      if (p && p.hidden) { open(); } else { close(); }
      return;
    }
    if (e.target.closest('[data-ceco-cat-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Editor de temas: cerrar al recargar la sección
  document.addEventListener('shopify:section:unload', close);
})();
